import * as r from "react";
import f from "react-dom";
import { P as c } from "./index-BrTLHETv.js";
import { u as l } from "./index-DuekHEmj.js";
import { jsx as u } from "react/jsx-runtime";
var p = "Portal", P = r.forwardRef((a, e) => {
  var o;
  const { container: s, ...i } = a, [m, n] = r.useState(!1);
  l(() => n(!0), []);
  const t = s || m && ((o = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : o.body);
  return t ? f.createPortal(/* @__PURE__ */ u(c.div, { ...i, ref: e }), t) : null;
});
P.displayName = p;
export {
  P
};
//# sourceMappingURL=index-CsGiVPqA.js.map
